





















































import { Vue, Component, Prop } from 'vue-property-decorator'
import { jumpPage } from '@/utils/mUtil'
import { CHECK_STATUS } from '@/constants/applyForm'

const tabList: any = [
  // {
  //   name: '上传视频',
  //   icon: require('@/assets/image/icon-upload.png'),
  //   id: 4,
  //   bg: require('@/assets/image/bg-upload.png'),
  // },

  // {
  //   name: '作品管理',
  //   icon: require('@/assets/image/icon-work.png'),
  //   id: 3,
  //   bg: require('@/assets/image/bg-work.png'),
  // },

  {
    name: '我的成就',
    icon: require('@/assets/image/icon-achieve.png'),
    id: 1,
    bg: require('@/assets/image/bg-achieve.png'),
  },

  {
    name: '征稿活动',
    icon: require('@/assets/image/icon-activity.png'),
    id: 2,
    bg: require('@/assets/image/bg-activity.png'),
  },
  {
    name: '实名认证',
    icon: require('@/assets/image/icon-certifi.png'),
    id: 6,
    bg: require('@/assets/image/bg-certifi.png'),
  },
  {
    name: '帮助中心',
    icon: require('@/assets/image/icon-question.png'),
    id: 5,
    bg: require('@/assets/image/bg-question.png'),
  },
]

@Component
export default class TabItems extends Vue {
  CHECK_STATUS = CHECK_STATUS

  // tabList: any = tabList
  public $refs!: { uploadEl: HTMLFormElement }
  $toast: any

  @Prop({ type: Boolean, default: false })
  inBuffer!: boolean

  @Prop({ type: Boolean, default: false })
  noVerifi!: boolean

  @Prop({ type: Boolean, default: false })
  isPerson!: boolean

  get textAct() {
    return this.$store.state.homeData.textAct
  }

  get isLogin() {
    return this.$store.getters.isLogin
  }

  get userInfo() {
    return this.$store.state.userInfo
  }

  get userInfoInapp() {
    return this.$store.state.userInfoInapp
  }

  get checkStatus() {
    console.log('noVerifi', this.noVerifi, this.isPerson)
    // if (this.userInfo.extInfo && !isNaN(this.userInfo.extInfo.settledStatus)) {
    //   return this.userInfo.extInfo.settledStatus
    // }
    // return CHECK_STATUS.NOT_APPLY

    // 判断入驻状态
    if (this.userInfo && !isNaN(this.userInfo.accountState)) {
      // 判断入驻状态
      if (this.userInfo && this.userInfo.accountState != 0) {
        return this.userInfo.accountState
      }
      // 判断是否入驻分账剧品类
      if (this.userInfo && this.userInfo.partnerState === 2) {
        return this.CHECK_STATUS.ISPARTNER
      }
    }
    return CHECK_STATUS.NOT_APPLY
  }

  get tabList() {
    if (!this.textAct || !this.textAct.length) return tabList
    return [
      tabList[0],
      tabList[1],
      Object.assign(tabList[2], this.textAct[0]),
      Object.assign(tabList[3], this.textAct[1]),
      tabList[4],
      tabList[5],
    ]
  }

  onChange(e: Event) {
    const target: HTMLInputElement = e.target as HTMLInputElement

    const files: FileList | null = target.files
    if (files) {
      const file = files[0]
      if (!file.type.includes('video')) {
        this.$refs.uploadEl.value = ''
        return this.$toast('非视频类型,请重新选择')
      }
      ;(window as any).VIDEO_FILE = file
      this.$router.push({ path: '/up/video' })
    }
  }

  isJigou() {
    if (this.userInfo.accountState === 1 || this.userInfo.accountState === 2) {
      return true
    } else {
      return false
    }
  }

  // eslint-disable-next-line
  clickHandler(item: any) {
    // console.log(this.isLogin, this.checkStatus == 1 , !this.noVerifi , (!this.inBuffer) , this.isJigou())
    // console.log(this.isLogin && this.checkStatus == 1 && !this.noVerifi && (!this.inBuffer) && this.isJigou())
    // 上传视频
    if (item.id == 4) {
      console.log('this.checkStatus', this.isLogin)
      if (!this.isLogin) {
        return this.$store.dispatch('login')
      } else {
        if (this.checkStatus === CHECK_STATUS.ISPARTNER) {
          this.$emit('showPtPop')
          return
        } else if (
          this.checkStatus == CHECK_STATUS.INFO_GET ||
          this.checkStatus == CHECK_STATUS.CANCEL
        ) {
          //审核不通过或者资格被取消
          this.$emit('showImprovePop')
          return
        }
        if (this.checkStatus === CHECK_STATUS.AUDITINT) {
          return this.$toast('请耐心等待入驻审核结果')
        } else if (this.checkStatus == CHECK_STATUS.GETTED && this.noVerifi) {
          return this.$toast('请先完成实名认证')
        } else if (this.checkStatus == CHECK_STATUS.NOT_APPLY) {
          this.$router.push({ path: '/apply' })
          return
        } else if (this.checkStatus !== CHECK_STATUS.GETTED) {
          // return this.$toast('请先申请成为创作者')
          this.$emit('showCertiPop')
          return
        }
      }
      return
    }
    // 作品管理
    if (item.id == 3) {
      if (!this.isLogin) {
        return this.$store.dispatch('login')
      }
      if (this.checkStatus === CHECK_STATUS.ISPARTNER) {
        this.$emit('showPtPop')
        return
      } else if (
        this.checkStatus == CHECK_STATUS.INFO_GET ||
        this.checkStatus == CHECK_STATUS.CANCEL
      ) {
        //审核不通过或者资格被取消
        this.$emit('showImprovePop')
        return
      }
      if (this.checkStatus === CHECK_STATUS.AUDITINT) {
        return this.$toast('请耐心等待入驻审核结果')
      } else if (this.checkStatus == CHECK_STATUS.GETTED) {
        if (this.noVerifi && this.inBuffer) {
          this.$router.push({ path: '/ideas/videos' })
        } else if (!this.noVerifi) {
          this.$router.push({ path: '/ideas/videos' })
        } else {
          if (
            this.userInfo.accountState != 1 &&
            this.userInfo.accountState != 2
          ) {
            return this.$toast('请先完成实名认证')
          }
        }
      } else if (this.checkStatus == CHECK_STATUS.NOT_APPLY) {
        this.$router.push({ path: '/apply' })
        return
      } else if (this.checkStatus !== CHECK_STATUS.GETTED) {
        // return this.$toast('请先申请成为创作者')
        this.$emit('showCertiPop')
        return
      }
      this.$router.push({ path: '/ideas/videos' })
    }

    // 帮助中心
    if (item.id === 5) {
      this.$router.push({ path: '/helpCenter' })
      return
    }

    // 实名认证
    if (item.id === 6) {
      console.log('isPerson', this.isPerson)
      if (this.checkStatus === CHECK_STATUS.AUDITINT) {
        return this.$toast('请耐心等待入驻审核结果')
      } else if (this.checkStatus == CHECK_STATUS.GETTED && this.noVerifi) {
        this.$router.push({ path: '/apply' })
        return
      } else if (
        this.checkStatus == CHECK_STATUS.INFO_GET ||
        this.checkStatus == CHECK_STATUS.CANCEL
      ) {
        //审核不通过或者资格被取消
        this.$emit('showImprovePop')
        return
      } else if (this.checkStatus == CHECK_STATUS.NOT_APPLY) {
        this.$router.push({ path: '/apply' })
      } else if (this.checkStatus !== CHECK_STATUS.GETTED) {
        // return this.$toast('请先申请成为创作者')
        this.$emit('showCertiPop')
        return
      }
      this.$router.push({ path: '/apply' })
    }

    if (!item.landing) return

    // 我的成就 唤醒
    if (item.id == 1) {
      if (this.checkStatus == CHECK_STATUS.NOT_APPLY) {
        this.$router.push({ path: '/apply' })
      } else {
        // 我的成就需要带上uuid
        !this.isLogin && this.$store.dispatch('login')
        this.isLogin &&
          jumpPage(`${item.landing}?artistId=${this.userInfo.uuid}`)
      }
      return
    }
    if (item.id == 2) {
      if (this.checkStatus == CHECK_STATUS.NOT_APPLY) {
        this.$router.push({ path: '/apply' })
      }
    }
    if (item.landing) {
      jumpPage(item.landing)
    }
  }
}
